/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.forms.rpc.HubSpotFormsSkillsService
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const createFormRpc = {
  serviceName: 'com.hubspot.forms.rpc.HubSpotFormsSkillsService',
  rpcName: 'createForm',
  auth: 'app',
  fingerprint: 'UWBsaV-zorAjdhrZyf8U3ZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getStatusRpc = {
  serviceName: 'com.hubspot.forms.rpc.HubSpotFormsSkillsService',
  rpcName: 'getStatus',
  auth: 'app',
  fingerprint: 'NISdc6bmzhBZfK9aKmd56JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const migrateLegacyFormRpc = {
  serviceName: 'com.hubspot.forms.rpc.HubSpotFormsSkillsService',
  rpcName: 'migrateLegacyForm',
  auth: 'app',
  fingerprint: 'pYEOEr5zAmLqHZjJFrzlApwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getMigrationStatusRpc = {
  serviceName: 'com.hubspot.forms.rpc.HubSpotFormsSkillsService',
  rpcName: 'getMigrationStatus',
  auth: 'app',
  fingerprint: 'NISdc6bmzhB9XUI2vW2-nZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateFormStyleRpc = {
  serviceName: 'com.hubspot.forms.rpc.HubSpotFormsSkillsService',
  rpcName: 'updateFormStyle',
  auth: 'app',
  fingerprint: 'jREoebOiYbYoW317YA59hZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getFormStylingStatusRpc = {
  serviceName: 'com.hubspot.forms.rpc.HubSpotFormsSkillsService',
  rpcName: 'getFormStylingStatus',
  auth: 'app',
  fingerprint: 'NISdc6bmzhAjLCIVmIQC3pwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createStagedFormRpc = {
  serviceName: 'com.hubspot.forms.rpc.HubSpotFormsSkillsService',
  rpcName: 'createStagedForm',
  auth: 'app',
  fingerprint: 'm6BOuP4V5jUpNKUFVKcOJZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getStagedFormStatusRpc = {
  serviceName: 'com.hubspot.forms.rpc.HubSpotFormsSkillsService',
  rpcName: 'getStagedFormStatus',
  auth: 'app',
  fingerprint: 'NISdc6bmzhCArxF_1OBvrpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getGenerativeAiEnabledRpc = {
  serviceName: 'com.hubspot.forms.rpc.HubSpotFormsSkillsService',
  rpcName: 'getGenerativeAiEnabled',
  auth: 'app',
  fingerprint: '7IXOBc5sE8m4TqItiBL8fJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};